import type { TranslationCatalog } from '../../shared/i18n';

export const translations: TranslationCatalog = {
  "Einkauf": {
    "tr": "Satın alma",
    "en": "Purchase"
  },
  "Einkaufsbelege": {
    "tr": "Satın alma belgeleri",
    "en": "Purchase documents"
  },
  "Lagertransfer": {
    "tr": "Depo transferi",
    "en": "Warehouse transfer"
  },
  "Lagertransfer Belege": {
    "tr": "Depo transfer belgeleri",
    "en": "Warehouse transfer documents"
  },
  "Lagerbestand Artikel": {
    "tr": "Ürün stokları",
    "en": "Stock by product"
  },
  "Bestandserfassung": {
    "tr": "Stok sayımı",
    "en": "Stock count entry"
  },
  "Bestandskorrektur Belege": {
    "tr": "Stok düzeltme belgeleri",
    "en": "Stock adjustment documents"
  },
  "Preise aktualisieren": {
    "tr": "Fiyatları güncelle",
    "en": "Update prices"
  },
  "Bestandskorrektur": {
    "tr": "Stok düzeltme",
    "en": "Stock adjustment"
  },
  "Art.Nr": {
    "tr": "Ürün no.",
    "en": "Product no."
  },
  "Bezeichnung": {
    "tr": "Açıklama",
    "en": "Description"
  },
  "Neu Bestand (VPE)": {
    "tr": "Yeni stok (koli)",
    "en": "New stock (packs)"
  },
  "Verpackung": {
    "tr": "Ambalaj",
    "en": "Packaging"
  },
  "VPE-Menge": {
    "tr": "Koli miktarı",
    "en": "Pack quantity"
  },
  "Rest": {
    "tr": "Kalan",
    "en": "Remaining"
  },
  "Akt Bestand": {
    "tr": "Mevcut stok",
    "en": "Current stock"
  },
  "Gruppe": {
    "tr": "Grup",
    "en": "Group"
  },
  "EK": {
    "tr": "Alış fiyatı",
    "en": "Cost"
  },
  "EK Lagerwert": {
    "tr": "Alış stok değeri",
    "en": "Stock value at cost"
  },
  "e-preis": {
    "tr": "Birim maliyet",
    "en": "Unit cost"
  },
  "e-preis *": {
    "tr": "Maliyet toplamı",
    "en": "Total cost"
  },
  "Lager": {
    "tr": "Depo",
    "en": "Warehouse"
  },
  "Suchen": {
    "tr": "Ara",
    "en": "Search"
  },
  "Status": {
    "tr": "Durum",
    "en": "Status"
  },
  "Alle": {
    "tr": "Tümü",
    "en": "All"
  },
  "Aktiv": {
    "tr": "Aktif",
    "en": "Active"
  },
  "Passiv": {
    "tr": "Pasif",
    "en": "Inactive"
  },
  "Bis": {
    "tr": "Bitiş",
    "en": "To"
  },
  "Stichtag": {
    "tr": "Kesim tarihi",
    "en": "As of date"
  },
  "Art.Nr / Bezeichnung (* = und)": {
    "tr": "Ürün no. / açıklama (* = ve)",
    "en": "Item no. / description (* = and)"
  },
  "E-preis > 0": {
    "tr": "Maliyet > 0",
    "en": "Cost > 0"
  },
  "Anzeigen": {
    "tr": "Göster",
    "en": "Show"
  },
  "Drucken ist für eine spätere Phase vorgesehen.": {
    "tr": "Yazdırma sonraki aşamada sunulacak.",
    "en": "Printing is planned for a later phase."
  },
  "Drucken ist für später vorgesehen.": {
    "tr": "Yazdırma sonraki aşamada sunulacak.",
    "en": "Printing is planned for a later phase."
  },
  "Drucken (später)": {
    "tr": "Yazdır (sonraki aşama)",
    "en": "Print (later)"
  },
  "Bestand wird gespeichert …": {
    "tr": "Stok kaydediliyor …",
    "en": "Saving stock …"
  },
  "Bestände werden abgeglichen …": {
    "tr": "Stoklar karşılaştırılıyor …",
    "en": "Reconciling stock …"
  },
  "Lagerbestand wird geladen …": {
    "tr": "Depo stoku yükleniyor …",
    "en": "Loading warehouse stock …"
  },
  "Belege werden geladen …": {
    "tr": "Belgeler yükleniyor …",
    "en": "Loading documents …"
  },
  "Preise werden geladen …": {
    "tr": "Fiyatlar yükleniyor …",
    "en": "Loading prices …"
  },
  "Preise werden gespeichert …": {
    "tr": "Fiyatlar kaydediliyor …",
    "en": "Saving prices …"
  },
  "Die Antwort ist unklar. Eingaben bleiben gesperrt, bis derselbe Speichervorgang erneut bestätigt wurde.": {
    "tr": "Yanıt belirsiz. Aynı kayıt işlemi tekrar doğrulanana kadar girişler kilitli kalır.",
    "en": "The response is uncertain. Editing stays locked until the same save request is confirmed again."
  },
  "Bestand erfassen": {
    "tr": "Stok gir",
    "en": "Enter stock"
  },
  "Speicherstatus klären / erneut senden": {
    "tr": "Kayıt durumunu kontrol et / tekrar gönder",
    "en": "Check save status / resend"
  },
  "Speichern ({count})": {
    "tr": "Kaydet ({count})",
    "en": "Save ({count})"
  },
  "Bestände abgleichen": {
    "tr": "Stokları karşılaştır",
    "en": "Reconcile stock"
  },
  "Eingaben verwerfen": {
    "tr": "Girişleri sil",
    "en": "Discard entries"
  },
  "Neu Bestand in VPE; Restmengen bleiben erhalten.": {
    "tr": "Yeni stok koli cinsindedir; kalan miktarlar korunur.",
    "en": "New stock is in packs; remainder quantities are retained."
  },
  "Gespeichert.": {
    "tr": "Kaydedildi.",
    "en": "Saved."
  },
  "Beleg öffnen": {
    "tr": "Belgeyi aç",
    "en": "Open document"
  },
  "Übernehmen": {
    "tr": "Uygula",
    "en": "Apply"
  },
  "Bestätigst du?": {
    "tr": "Onaylıyor musunuz?",
    "en": "Confirm?"
  },
  "Bestandskorrektur speichern": {
    "tr": "Stok düzeltmesini kaydet",
    "en": "Save stock adjustment"
  },
  "Aktuelle Bestände laden und die eingegebenen Zählmengen behalten? Bitte die neue Differenz anschließend prüfen.": {
    "tr": "Girilen sayım miktarlarını koruyarak güncel stoklar yüklensin mi? Ardından yeni farkı kontrol edin.",
    "en": "Load current stock and retain the entered counts? Please check the new difference afterwards."
  },
  "Erfasste Bestände verwerfen?": {
    "tr": "Girilen stoklar silinsin mi?",
    "en": "Discard entered stock counts?"
  },
  "Ein erfasster Artikel ist nicht mehr vorhanden.": {
    "tr": "Girilen ürünlerden biri artık mevcut değil.",
    "en": "An entered item no longer exists."
  },
  "{count} Artikel · Seite {page}": {
    "tr": "{count} ürün · Sayfa {page}",
    "en": "{count} items · Page {page}"
  },
  "{count} Belege · Seite {page}": {
    "tr": "{count} belge · Sayfa {page}",
    "en": "{count} documents · Page {page}"
  },
  "Aktuell: {quantity} VPE · Rest {rest}": {
    "tr": "Mevcut: {quantity} koli · Kalan {rest}",
    "en": "Current: {quantity} packs · Remainder {rest}"
  },
  "{count} Artikel werden korrigiert.": {
    "tr": "{count} ürünün stoku düzeltilecek.",
    "en": "Stock will be adjusted for {count} items."
  },
  "{quantity} VPE (Differenz {difference})": {
    "tr": "{quantity} koli (Fark {difference})",
    "en": "{quantity} packs (Difference {difference})"
  },
  "Datum": {
    "tr": "Tarih",
    "en": "Date"
  },
  "Beleg-Nr": {
    "tr": "Belge no.",
    "en": "Document no."
  },
  "Art": {
    "tr": "Tür",
    "en": "Type"
  },
  "Lieferant-Nr": {
    "tr": "Tedarikçi no.",
    "en": "Supplier no."
  },
  "Firma": {
    "tr": "Firma",
    "en": "Company"
  },
  "PLZ": {
    "tr": "Posta kodu",
    "en": "Postal code"
  },
  "Ort": {
    "tr": "Şehir",
    "en": "City"
  },
  "Betrag": {
    "tr": "Tutar",
    "en": "Amount"
  },
  "Währung": {
    "tr": "Para birimi",
    "en": "Currency"
  },
  "Fremdwährung": {
    "tr": "Döviz tutarı",
    "en": "Foreign currency amount"
  },
  "Ziellager": {
    "tr": "Hedef depo",
    "en": "Destination warehouse"
  },
  "Mitarbeiter": {
    "tr": "Personel",
    "en": "Employee"
  },
  "Notizen": {
    "tr": "Notlar",
    "en": "Notes"
  },
  "Jahr": {
    "tr": "Yıl",
    "en": "Year"
  },
  "Von": {
    "tr": "Başlangıç",
    "en": "From"
  },
  "Beleg-Nr / Firma / Notizen": {
    "tr": "Belge no. / firma / notlar",
    "en": "Document no. / company / notes"
  },
  "Belegart": {
    "tr": "Belge türü",
    "en": "Document type"
  },
  "Öffnen": {
    "tr": "Aç",
    "en": "Open"
  },
  "L": {
    "tr": "D",
    "en": "S"
  },
  "VPE": {
    "tr": "Koli içi",
    "en": "Pack size"
  },
  "Menge": {
    "tr": "Miktar",
    "en": "Quantity"
  },
  "E-preis": {
    "tr": "Birim fiyat",
    "en": "Unit price"
  },
  "E-preis (Basis)": {
    "tr": "Birim maliyet (baz)",
    "en": "Unit cost (base)"
  },
  "Zollkosten": {
    "tr": "Gümrük gideri",
    "en": "Customs cost"
  },
  "Versandkosten": {
    "tr": "Nakliye gideri",
    "en": "Shipping cost"
  },
  "Neu EK": {
    "tr": "Yeni alış fiyatı",
    "en": "New cost"
  },
  "EK %": {
    "tr": "Alış %",
    "en": "Cost %"
  },
  "Akt. EK": {
    "tr": "Mevcut alış fiyatı",
    "en": "Current cost"
  },
  "Neu Kosten": {
    "tr": "Yeni maliyet",
    "en": "New cost"
  },
  "A/P": {
    "tr": "A/P",
    "en": "A/P"
  },
  "Bitte zuerst einen gespeicherten Einkaufsbeleg auswählen.": {
    "tr": "Önce kayıtlı bir satın alma belgesi seçin.",
    "en": "Please select a saved purchase document first."
  },
  "Einkaufsbelege öffnen": {
    "tr": "Satın alma belgelerini aç",
    "en": "Open purchase documents"
  },
  "Preise aktualisieren · Beleg {id}": {
    "tr": "Fiyatları güncelle · Belge {id}",
    "en": "Update prices · Document {id}"
  },
  "Übernehmen ({count})": {
    "tr": "Uygula ({count})",
    "en": "Apply ({count})"
  },
  "Änderungen verwerfen und neu laden?": {
    "tr": "Değişikliklerden vazgeçilip yeniden yüklensin mi?",
    "en": "Discard changes and reload?"
  },
  "Neu laden": {
    "tr": "Yeniden yükle",
    "en": "Reload"
  },
  "Passiv → Aktiv": {
    "tr": "Pasif → Aktif",
    "en": "Inactive → Active"
  },
  "Preise wurden übernommen.": {
    "tr": "Fiyatlar uygulandı.",
    "en": "Prices have been applied."
  },
  "H: Vorschlag · E: zur Übernahme markiert · Übernommene Preise (K) sind ausgeblendet. Nur bearbeitete Preise werden gespeichert.": {
    "tr": "H: Öneri · E: uygulanmak üzere işaretli · Uygulanan fiyatlar (K) gizlidir. Yalnızca düzenlenen fiyatlar kaydedilir.",
    "en": "H: Suggested · E: marked for application · Applied prices (K) are hidden. Only edited prices are saved."
  },
  "Preis bearbeiten": {
    "tr": "Fiyatı düzenle",
    "en": "Edit price"
  },
  "Neu VK%": {
    "tr": "Yeni satış marjı %",
    "en": "New sales margin %"
  },
  "Speichervorgang läuft bereits.": {
    "tr": "Kayıt işlemi zaten sürüyor.",
    "en": "A save is already in progress."
  },
  "Bitte Lager auswählen.": {
    "tr": "Lütfen depo seçin.",
    "en": "Please select a warehouse."
  },
  "Unbekannte Belegart.": {
    "tr": "Bilinmeyen belge türü.",
    "en": "Unknown document type."
  },
  "Bitte gültigen Zeitraum wählen.": {
    "tr": "Lütfen geçerli bir tarih aralığı seçin.",
    "en": "Please select a valid date range."
  },
  "Einkaufsbeleg nicht gefunden.": {
    "tr": "Satın alma belgesi bulunamadı.",
    "en": "Purchase document not found."
  },
  "Keine Berechtigung für Einkaufswerte.": {
    "tr": "Alış değerlerini görme yetkiniz yok.",
    "en": "No permission to view purchase values."
  },
  "Die Daten wurden zwischenzeitlich geändert. Ihre Eingaben bleiben erhalten. Bitte neu laden und prüfen.": {
    "tr": "Veriler bu sırada değiştirildi. Girişleriniz korunuyor. Lütfen yeniden yükleyip kontrol edin.",
    "en": "The data has changed. Your entries are retained. Please reload and check."
  },
  "Bitte mindestens einen neuen Bestand eingeben (maximal 5000 Artikel). ": {
    "tr": "Lütfen en az bir yeni stok girin (en fazla 5000 ürün).",
    "en": "Please enter at least one new stock count (maximum 5000 items)."
  },
  "Artikel, Bestand oder Bestandsversion ist ungültig.": {
    "tr": "Ürün, stok veya stok sürümü geçersiz.",
    "en": "Item, stock count or stock version is invalid."
  },
  "Ein Artikel darf nur einmal erfasst werden.": {
    "tr": "Bir ürün yalnızca bir kez girilebilir.",
    "en": "An item may only be entered once."
  },
  "Lager nicht eindeutig vorhanden.": {
    "tr": "Depo bulunamadı veya birden fazla kayıt var.",
    "en": "Warehouse was not found or is not unique."
  },
  "Artikel nicht eindeutig vorhanden.": {
    "tr": "Ürün bulunamadı veya birden fazla kayıt var.",
    "en": "Item was not found or is not unique."
  },
  "Die Verpackungsmenge muss größer als null sein.": {
    "tr": "Ambalaj miktarı sıfırdan büyük olmalıdır.",
    "en": "Pack quantity must be greater than zero."
  },
  "Die Bestandsmenge ist zu groß.": {
    "tr": "Stok miktarı çok büyük.",
    "en": "The stock quantity is too large."
  },
  "Nummernkreis für Bestandskorrektur fehlt.": {
    "tr": "Stok düzeltmesi için numara sayacı eksik.",
    "en": "The stock adjustment number sequence is missing."
  },
  "Belegnummer bereits vorhanden. Nummernkreis prüfen.": {
    "tr": "Belge numarası zaten mevcut. Numara sayacını kontrol edin.",
    "en": "Document number already exists. Check the number sequence."
  },
  "Ungültige Preisänderung.": {
    "tr": "Geçersiz fiyat değişikliği.",
    "en": "Invalid price change."
  },
  "Bitte Preise auswählen.": {
    "tr": "Lütfen fiyatları seçin.",
    "en": "Please select prices."
  },
  "Preisfeld oder Preis ist ungültig.": {
    "tr": "Fiyat alanı veya fiyat geçersiz.",
    "en": "Price field or price is invalid."
  },
  "Eine Preisänderung wurde mehrfach übergeben.": {
    "tr": "Bir fiyat değişikliği birden fazla kez gönderildi.",
    "en": "A price change was submitted more than once."
  },
  "Belegzeile nicht gefunden.": {
    "tr": "Belge satırı bulunamadı.",
    "en": "Document line not found."
  },
  "Dieser Preis wurde bereits übernommen.": {
    "tr": "Bu fiyat zaten uygulanmış.",
    "en": "This price has already been applied."
  },
  "Mehrere Zeilen desselben Artikels enthalten unterschiedliche neue Preise.": {
    "tr": "Aynı ürünün birden fazla satırında farklı yeni fiyatlar var.",
    "en": "Multiple lines of the same item contain different new prices."
  },
  "Vk1": {
    "tr": "Satış 1",
    "en": "Sale 1"
  },
  "VK1": {
    "tr": "Satış 1",
    "en": "Sale 1"
  },
  "VK1 Lagerwert": {
    "tr": "Satış1 stok değeri",
    "en": "Stock value at price1"
  },
  "Neu VK1": {
    "tr": "Yeni satış1",
    "en": "New price1"
  },
  "Vk2": {
    "tr": "Satış 2",
    "en": "Sale 2"
  },
  "VK2": {
    "tr": "Satış 2",
    "en": "Sale 2"
  },
  "VK2 Lagerwert": {
    "tr": "Satış2 stok değeri",
    "en": "Stock value at price2"
  },
  "Neu VK2": {
    "tr": "Yeni satış2",
    "en": "New price2"
  },
  "Vk3": {
    "tr": "Satış 3",
    "en": "Sale 3"
  },
  "VK3": {
    "tr": "Satış 3",
    "en": "Sale 3"
  },
  "VK3 Lagerwert": {
    "tr": "Satış3 stok değeri",
    "en": "Stock value at price3"
  },
  "Neu VK3": {
    "tr": "Yeni satış3",
    "en": "New price3"
  },
  "Vk4": {
    "tr": "Satış 4",
    "en": "Sale 4"
  },
  "VK4": {
    "tr": "Satış 4",
    "en": "Sale 4"
  },
  "VK4 Lagerwert": {
    "tr": "Satış4 stok değeri",
    "en": "Stock value at price4"
  },
  "Neu VK4": {
    "tr": "Yeni satış4",
    "en": "New price4"
  }
};
